export default {"src":"/_next/static/media/SVV.48c807a7.svg","height":18,"width":18};